<template>
  <modal type="text/x-template" id="modalProduct">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header">
              <div class="header">
                <h4 class="title">Resumen de la Venta # {{sale.saleNumber}}</h4>
                {{sale.date}}
              </div>
              <div class="close-modal">
                <button class="button-close" @click="$emit('close')">X</button>
              </div>
            </div>

            <div class="modal-body">
              <v-container fluid>
                <v-layout wrap>
                  <v-flex xs9 class="primary">
                    <div class="conteiner-left">
                      <v-container fluid>
                        <v-layout wrap>
                          <v-flex xs7 class="primary">
                            <div class="image">
                              <img src="../assets/smile.svg" width="25px" height="25px" />
                              <h5 class="customer-info">{{sale.customerName}}</h5>
                            </div>
                          </v-flex>
                          <v-flex xs5 class="primary">
                            <h5 class="status">Estado:</h5>
                          </v-flex>
                        </v-layout>
                      </v-container>

                      <v-container fluid>
                        <v-layout wrap>
                          <v-flex xs7 class="primary">
                            <div class="image">
                              <img src="../assets/phone.svg" width="25px" height="25px" />
                              <h5 class="customer-info">{{sale.customerNumber}}</h5>
                            </div>
                          </v-flex>
                          <v-flex xs5 class="primary">
                            <h5
                              v-if="sale.status === 'Finalizada'"
                              style="color: green"
                            >{{sale.status}}</h5>
                            <h5
                              v-else-if="sale.status === 'Anulada'"
                              style="color: red"
                            >{{sale.status}}</h5>
                            <h5 v-else style="color: #a6a600">{{sale.status}}</h5>
                          </v-flex>
                        </v-layout>
                      </v-container>

                      <div>
                        <div class="image container">
                          <img src="../assets/MailLogo.svg" width="25px" height="25px" />
                          <h5 class="customer-info">{{sale.customerEmail}}</h5>
                        </div>
                      </div>
                      <div>
                        <div class="image container">
                          <img src="../assets/house.svg" width="25px" height="25px" />
                          <h5 class="customer-info">{{sale.customerAdress}}</h5>
                        </div>
                      </div>

                      <v-container fluid>
                        <v-layout wrap>
                          <v-flex xs7 class="primary">
                            <div class="image">
                              <img src="../assets/origin.svg" width="25px" height="25px" />
                              <h5 class="customer-info">{{sale.origin}}</h5>
                            </div>
                          </v-flex>
                          <v-flex xs5 class="primary">
                            <h5 class="paymentType">{{sale.paymentType}}</h5>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </div>
                  </v-flex>
                  <v-flex xs3 class="primary">
                    <div class="item-container">
                      <div class="items">
                        <h5 style="color: green">$ {{sale.amountAditionals}}</h5>Adicional
                      </div>

                      <div class="items">
                        <h5 class="price">$ {{sale.total}}</h5>Total de la venta
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>

            <div class="modal-footer">
              <h5 class="produts-title">Detalle de productos</h5>

              <div>
                <table class="product-table">
                  <!-- <thead>
                  <tr>
                    <td class="td-code">Descripción</td>

                    <td class="td-total">Total</td>
                  </tr>
                  </thead>-->
                  <tbody>
                    <tr v-for="prod in sale.products" :key="prod.code" class="listProducts">
                      <td class="product-code">Cod: {{prod.code}}</td>
                      <td class="product-details">{{prod.quantity}}</td>
                      <td class="product-details">x</td>
                      <td class="product-details product-name">{{prod.name}}</td>
                      <td class="product-total">$ {{prod.total}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </modal>
</template>

<script>
export default {
  props: {
    sale: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {}
};
</script>

<style scoped>
.header {
  width: 90%;
  margin-left: 10%;
  padding: 10px;
}

.modal-footer {
  display: inherit;
}

.produts-title {
  text-align: center;
  font-weight: bold;
}

.listProducts {
  margin-top: 10px;
  padding: 15px;
}

.product-code {
  padding-left: 50px;
  width: 200px;
}

.price {
  font-size: 25px;
  font-weight: 800;
  color: green;
  line-height: 1;
  padding-right: 5px;
  font-style: bold;
}

.paymentType {
  color: #000071;
  font-weight: 800;
  font-style: bold;
}

.items {
  padding: 20px;
  text-align: center;
}

.container {
  padding: 5px;
}

.item-container {
  padding: 10px;
  /* margin-bottom: 15px; */
}

.status {
  text-align: start;
}

.product-details {
  padding: 10px;
}

.product-name {
  width: 480px;
}

.product-total {
  margin-top: 10px;
  padding: 15px;
}

.customer-info {
  align-self: center;
  margin-top: 1px;
  margin-left: 20px;
}

.image {
  align-self: center;
  display: -webkit-inline-box;
}

.title {
  font-weight: 800;
}
.close-modal {
  width: 10%;
  text-align: end;
}
.button-close {
  background: red;
  border-radius: 20px;
  padding: 10px;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 60%;
  margin: 0px auto;
  padding: 0px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  min-width: fit-content;
  overflow-y: auto;
  border-radius: 10px !important;
}

.modal-header {
  margin-top: 0;
  color: #212529;
  text-align: center;
  justify-content: center;
  align-self: center;
}

.modal-body {
  margin: 5px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>


// WEBPACK FOOTER //
// src/components/ModalTracking.vue